<style>
.Secondary_Action {
    height: 240px;
    width: 100%;
}

.new_group {
    width: 100px;
    padding: 0;
}

</style>
<script>
    import { Col, Container, Row } from "sveltestrap";
    function changeToScreenGroup(groupNumber) {
        window.location = `#/brite-host/${groupNumber}/manage-screens`
    }
</script>
<Container>
    <div class="Page_Title">
        {window.getBusinessName()}'s Screen Groups
    </div>
</Container>
<Container>
    <Row class="justify-content-center">
        <Col sm="4" xs="8">
            <div class="Secondary_Action" on:click = {() => changeToScreenGroup(0)}>
                <h3 class="light-text">Screen Group 1</h3>
                <!-- <img src="static/icons/TV_Screen.png" alt="TV Screen"/> -->
            </div>
        </Col>
        <Col sm="4" xs = "8">
            <div class="Secondary_Action Grey_Out">
                <h3 class="light-text">New Screen Group</h3>
                <img src="static/icons/New_Plus_Sign.png" class="new_group" alt="New Group"/>
            </div>
        </Col>
    </Row>
</Container>